import { BaseController } from "./_BaseController";
import { TypedMatNode } from "../_Base";
import { Material } from "three";
import { NodeParamsConfig, ParamConfig } from "../../utils/params/ParamsConfig";
import { isBooleanTrue } from "../../../../core/BooleanValue";
export function UniformsTransparencyParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.transparent = ParamConfig.BOOLEAN(0);
      this.opacity = ParamConfig.FLOAT(1);
      this.alphaTest = ParamConfig.FLOAT(0);
    }
  };
}
class TransparencyParamsConfig extends UniformsTransparencyParamConfig(NodeParamsConfig) {
}
class TransparencyMatNode extends TypedMatNode {
  createMaterial() {
    return new Material();
  }
}
export class UniformsTransparencyController extends BaseController {
  constructor(node) {
    super(node);
    this.node = node;
  }
  static update(node) {
    const material = node.material;
    const pv = node.pv;
    this._updateTransparency(material, pv);
  }
  static _updateTransparency(mat, pv) {
    mat.transparent = isBooleanTrue(pv.transparent);
    this._updateCommon(mat, pv);
  }
  static _updateCommon(mat, pv) {
    const shaderMaterial = mat;
    if (shaderMaterial.uniforms && shaderMaterial.uniforms.opacity) {
      shaderMaterial.uniforms.opacity.value = pv.opacity;
    }
    mat.opacity = pv.opacity;
    if (shaderMaterial.uniforms && shaderMaterial.uniforms.alphaTest) {
      shaderMaterial.uniforms.alphaTest.value = pv.alphaTest;
    }
    mat.alphaTest = pv.alphaTest;
    const customMaterials = mat.customMaterials;
    if (customMaterials) {
      const customNames = Object.keys(customMaterials);
      for (let customName of customNames) {
        const customMaterial = customMaterials[customName];
        if (customMaterial) {
          this._updateCommon(customMaterial, pv);
        }
      }
    }
  }
}
